import {
  AssignmentViewModel,
  CaseTypeEnum,
  DrivingPolicyReportDto,
} from 'api/model';
import Dropdown from 'components/Dropdown';
import ConfirmDeleteCaseModal from './ConfirmDeleteCaseModal';
import useModalStack from 'contexts/modal/useModalStack';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEllipsisVertical,
  faTrashCan,
} from '@fortawesome/free-solid-svg-icons';
import ReplacePlaceholderCarButton from 'components/DetailedCase/CaseAssignments/ReplacePlaceholderCarModal';
import styled from 'styled-components';
import TextButton from 'components/inputs/TextButton';
import { useState } from 'react';

const CaseButton = styled(TextButton)<{ strikeThrough?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  gap: 5px;
  padding: 2px;
  width: 100%;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 5px;
`;

type Props = {
  model: AssignmentViewModel;
  drivingPolicyReport: DrivingPolicyReportDto | undefined;
};

const PlaceHolderCaseActionsButton: React.FC<Props> = ({
  model,
  drivingPolicyReport,
}) => {
  const modalStack = useModalStack();

  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);

  const handleDeletePlaceholder = () => {
    if (model.case.caseTypeID !== CaseTypeEnum.Placeholder) {
      return; // only placeholders can be deleted
    }

    modalStack.push(
      <ConfirmDeleteCaseModal
        caseModel={model.case}
        onConfirm={() => modalStack.pop()}
        onCancel={() => modalStack.pop()}
      />
    );
  };

  return (
    <Dropdown
      content={
        dropdownOpen && (
          <ContentWrapper>
            <CaseButton onClick={handleDeletePlaceholder}>
              Ta bort{' '}
              <FontAwesomeIcon
                style={{ marginLeft: 'auto' }}
                icon={faTrashCan}
              />
            </CaseButton>

            <ReplacePlaceholderCarButton
              assignment={model}
              drivingPolicyReport={drivingPolicyReport}
            />
          </ContentWrapper>
        )
      }
      onLostFocus={() => {
        if (dropdownOpen) {
          setDropdownOpen(false);
        }
      }}
    >
      <TextButton onClick={() => setDropdownOpen(!dropdownOpen)}>
        <FontAwesomeIcon icon={faEllipsisVertical} />
      </TextButton>
    </Dropdown>
  );
};
export default PlaceHolderCaseActionsButton;
